enum GoalType {
    preventCustomerEscalation = 'PCE',
    improveTeamPerformance = 'ITP',
    upgradeQualityStrategy = 'UQS',
}

export default GoalType;
